<template>
  <div id="app">
    <router-view></router-view>
    <InventoryTicker />
    <TickerDetailModal />
    <CookieConsent />
  </div>
</template>

<script>
import CookieConsent from './components/CookieConsent.vue'
import InventoryTicker from './components/InventoryTicker.vue'
import TickerDetailModal from './components/TickerDetailModal.vue'

export default {
  name: 'App',
  components: {
    CookieConsent,
    InventoryTicker,
    TickerDetailModal
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--color-base-content);
  margin: 0;
}
/* Feel free to adjust or add more styles */
</style>